import { Box } from "@mui/material";
import moment from "moment";
import { useState } from "react";
import { useParams } from "react-router-dom";

import { AdminService, CRMService } from "../../services";
import { ActionButton, FormDialog, InputField, SelectField } from "../v3";

export const AddEditTask = ({
  open = false,
  taskData,
  setTaskData,
  selectedAssignee,
  setSelectedAssignee,
  selectedTaskStatus,
  setSelectedTaskStatus,
  onClose = () => {},
  onSuccess = (taskData: any) => {},
  isEdit = false,
}: any) => {
  const { id: leadId } = useParams();
  const [errors, setErrors] = useState({});

  const handleClearForm = () => {
    setTaskData({ description: "", dueDate: moment().format("YYYY-MM-DD") });
    setSelectedAssignee(null);
    setSelectedTaskStatus(null);
  };

  const handleStatusChange = (value) => {
    setSelectedTaskStatus(value);
  };

  const handleAssigneeChange = (value) => {
    setSelectedAssignee(value);
  };

  const updateDetailsState = (e) => {
    const { name, value } = e.target;
    setTaskData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCloseModal = () => {
    setErrors({});
    handleClearForm();
    onClose();
  };

  const handleSaveTask = () => {
    const validationErrors: any = {};

    if (!selectedAssignee?.id) validationErrors.assigneeId = "Please select an assignee";
    if (!selectedTaskStatus?.id) validationErrors.selectedStatus = "Please select a status";
    if (!taskData?.dueDate) validationErrors.dueDate = "Due date is required";

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const taskPayload = {
      ...(isEdit ? {} : { leadId: Number(leadId) }), // only include leadId for create
      leadStatusId: selectedTaskStatus.id,
      dueDate: taskData.dueDate,
      description: taskData.description,
      assigneeId: selectedAssignee.id,
    };

    onSuccess?.(taskPayload);
    setErrors({});
    handleClearForm();
  };

  return (
    <FormDialog
      sx={{ width: "100%" }}
      open={open}
      onClose={handleCloseModal}
      title={isEdit ? "Edit Task" : "Add Task"}
      actions={
        <>
          <ActionButton buttonText="Cancel" onButtonClick={handleCloseModal} variant="outlined" />
          <ActionButton buttonText="Save" onButtonClick={handleSaveTask} disabled={false} />
        </>
      }
    >
      <Box mt={1}>
        <Box className="fl gap-2">
          <SelectField
            label="Status"
            value={selectedTaskStatus}
            getData={CRMService.getLeadStatuses}
            optionValueFields={["name"]}
            required
            error={!!errors.selectedStatus}
            helperText={errors.selectedStatus}
            onChange={handleStatusChange}
            style={{ width: "100%" }}
          />
        </Box>

        <Box className="fl gap-2">
          <SelectField
            label="Assignee"
            value={selectedAssignee}
            required
            getData={AdminService.getUserList}
            getDataStaticFilters={{ type: "USER" }}
            optionValueFields={["firstName", "lastName"]}
            error={!!errors.assigneeId}
            helperText={errors.assigneeId}
            onChange={handleAssigneeChange}
            style={{ width: "100%" }}
          />
          <Box className="fl gap-2">
            <InputField
              label="Due Date"
              type="date"
              name="dueDate"
              value={taskData?.dueDate || ""}
              onChange={updateDetailsState}
              error={!!errors.dueDate}
              helperText={errors.dueDate}
              fullWidth
            />
          </Box>
        </Box>
        <Box className="fl gap-2">
          <InputField
            name="description"
            placeholder="Description"
            value={taskData.description}
            onChange={updateDetailsState}
            multiline={true}
            minRows={6}
            fullWidth={true}
            error={!!errors.description}
            helperText={errors.description}
            style={{
              margin: "14px 0px",
              padding: "14px",
              borderRadius: "10px",
              backgroundColor: "#EEEEEE",
              "& .MuiOutlinedInput-root": {
                padding: 0,
                backgroundColor: "transparent",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
          />
        </Box>
      </Box>
    </FormDialog>
  );
};
